import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Loader, TextField } from "../../components";
import {
  Avatar,
  Col,
  Divider,
  Modal,
  Pagination,
  Row,
  Switch,
  Table,
  Tabs,
  Typography,
} from "antd";
import Header from "../../components/Layout/Header";
import { GamesActions, PrizePoolAction } from "../../store/actions";
import { IoIosInformationCircleOutline } from "react-icons/io";
import {
  FaCheckDouble,
  FaClock,
  FaEye,
  FaPen,
  FaRegQuestionCircle,
  FaSearch,
  FaArrowLeft,
} from "react-icons/fa";
import { Images, Utils } from "../../config";
import moment from "moment";
import { Input } from "antd";
import { Actions } from "../../components/atoms/Actions";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { CustomButton } from "../../components/ui/button/CustomButton";
import { set } from "date-fns";
import { render } from "@testing-library/react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const { TabPane } = Tabs;

const PrizePoolDetails = () => {
  const history = useHistory();
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const data = useSelector((store) => {
    return store.PrizePoolReducer;
  });
  console.log(data, "Burhannnnn");

  useEffect(() => {
    const getUsers = {
      id,
      limit: 10,
      offSet: 0,
    };
    dispatch(PrizePoolAction.GetLuckydrawPoolsDetail(getUsers));
  }, []);

  //   useEffect(() => {
  //     if (tabName === "done") {
  //       dispatch(PrizePoolAction.GetPrizePool());
  //     } else if (tabName === "manager") {
  //       console.log(tabName, "dwdadef");

  //       dispatch(PrizePoolAction.GetLuckydrawConfig());
  //     } else if (tabName === "list") {
  //       const getUsers = {
  //         limit: 10,
  //         offSet: 0,
  //       };
  //       dispatch(PrizePoolAction.GetLuckydrawPools(getUsers));
  //     } else if (tabName === "winner") {
  //       const getUsers = {
  //         limit: 10,
  //         offSet: 0,
  //       };
  //       dispatch(PrizePoolAction.GetLuckydrawWinners(getUsers));
  //     }
  //   }, [tabName]);

  const headerProps = {
    mainHeading: "Prize Pool Management  Details",
    subHeading: ``,
  };

  const handle_payDone = (p) => {
    const limit = 10;
    let offSet = (p - 1) * limit;
    setCurrentPage(p);
    const getUsersByPage = {
      limit,
      offSet,
    };
    dispatch(PrizePoolAction.GetLuckydrawWinners(getUsersByPage));
  };

  const columns = [
    {
      title: "",
      dataIndex: "imageThumbUrl",
      key: "imageThumbUrl",
      width: "1%",
      render: (i, b) => <Avatar src={b?.user?.imageUrl} />,
    },
    {
      title: "User Name",
      dataIndex: "fullName",
      key: "fullName",
      render: (i, record) => `${record?.user?.fullName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (i, record) => `${record?.user?.email}`,
    },
  ];

  return (
    <>
      <Layout.DashboardHeader
        columnSpacing={5}
        customizeStyle={{
          display: "flex",
          padding: 25,
          backgroundColor: "#fffcfc",
          marginLeft: 2,
        }}
      >
        <Header headings={headerProps} />

        <div className="tbl_game">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: "10px",
              width: "fit-content",
            }}
            onClick={() => history.goBack()}
          >
            <FaArrowLeft size={20} style={{ marginRight: "5px" }} />
            <Typography.Text strong>Back</Typography.Text>
          </div>
          <Table
            dataSource={data?.poolsDetails?.rows}
            columns={columns}
            pagination={false}
          />
          <div style={{ width: "100%", marginTop: "3rem", marginBottom: "3rem" }}>
            <Pagination
              responsive="true"
              showLessItems="true"
              defaultCurrent={1}
              current={currentPage}
              total={data?.poolsDetails?.count ? data?.poolsDetails?.count : 0}
              onChange={(p) => {
                handle_payDone(p);
              }}
            />
          </div>
        </div>
      </Layout.DashboardHeader>
    </>
  );
};
export default PrizePoolDetails;
